import { useCallback } from 'react';
import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

import { Text } from '../../components/Typography';
import { Section } from '../../components/Section';
import { CheckBox } from '../../components/Input';

import { getTellUsAboutYouSections } from '../../selectors/user';

type PreferencesProps = {
  onChange: (fields: string[]) => void;
  selectedFields: string[];
};

export const Preferences = React.memo<PreferencesProps>(
  ({ onChange, selectedFields }) => {
    const sections = getTellUsAboutYouSections();
    const handleCheckBoxChange = useCallback(
      ({ target }: React.ChangeEvent<HTMLInputElement>) => {
        const option = target.name;
        const nextSelectedFields = !target.checked
          ? [...selectedFields].filter((field) => field !== option)
          : [...selectedFields, option];

        onChange(nextSelectedFields);
      },
      [onChange, selectedFields]
    );

    return (
      <Section as={'fieldset'}>
        <Text as={'h3'} variant={'title'}>
          Raccontaci qualcosa di te
        </Text>

        {sections.map((section) => (
          <Section as={'div'} key={section.id}>
            <p>{section.title}</p>

            <Row>
              {section.options.map((option, index) => (
                <Col key={index} xs={6}>
                  <CheckBox
                    checked={selectedFields.includes(option)}
                    id={`${option.toLowerCase().replace(/\s/g, '-')}-checkbox`}
                    name={option}
                    onChange={handleCheckBoxChange}
                  >
                    {option}
                  </CheckBox>
                </Col>
              ))}
            </Row>
          </Section>
        ))}
      </Section>
    );
  }
);
